import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { Tableau } from '../../common/utilities/TableauLog';
import { Module } from '../Module';
import { L10n } from './L10n';

/**
 * So we can use the old angular-translate Interface with a Localize implementation
 */

Module.instance().factory('$translate', ['$q',
  ($q: ng.IQService) => {
    // We'll dynamically reference things in Messages for this adapter, so remove the type info.
    const untypedMessages: any = Messages;
    const escapeInterpolations = [
      L10n.Interpolations.Escaped,
      L10n.Interpolations.CountEscaped,
      L10n.Interpolations.FloatEscaped
    ];
    function escape(str: string) {
      // This is the escape strategy that angular-translate uses in the version we were using
      return angular.element('<div></div>').text(str).html();
    }
    function translate(translationId: string, interpolateParams?: any, interpolationId?: string): string {
      if (!translationId) {
        return '';
      }
      const isIntegerInterpolation = interpolationId === L10n.Interpolations.Count || interpolationId === L10n.Interpolations.CountEscaped;
      const isFloatInterpolation = interpolationId === L10n.Interpolations.Float || interpolationId === L10n.Interpolations.FloatEscaped;
      const isNumberInterpolation = isIntegerInterpolation || isFloatInterpolation;
      const isEscapedInterpolation = escapeInterpolations.indexOf(interpolationId) !== -1;
      const processedInterpolateParams: any = {};
      if (interpolateParams) {
        Object.keys(interpolateParams).forEach(key => {
          const val = interpolateParams[key];
          if (_.isNumber(val) && isNumberInterpolation) {
            const localizedVal = isIntegerInterpolation ?
              L10n.localizedCount(val) :
              L10n.localizedFloat(val);
            // We must add _LOC to the key for numbers. See CL 412765 for details.
            const newKey = `${key}_LOC`;
            processedInterpolateParams[key] = val;
            processedInterpolateParams[newKey] = isEscapedInterpolation ? escape(localizedVal) : localizedVal;
          } else if (isEscapedInterpolation) {
            processedInterpolateParams[key] = escape(val);
          } else {
            processedInterpolateParams[key] = val;
          }
        });
      }

      // In case of an unknown translation id, give the user a warning, but don't throw
      if (!untypedMessages[translationId]) {
        Tableau.Logger().error(`Unrecognized translationId ${translationId}`);
        return translationId;
      }
      return untypedMessages[translationId](processedInterpolateParams);
    }
    const unimplementedMethod = () => {
      throw Error('This method is part of the angular-translate $translate service API was not implemented' +
        'during the port to @tableau/localize-api. If reading this, you probably need to implement it.');
    };
    const localizeToNgTranslateAdapter: ng.translate.ITranslateService = _.assign(
      (translationId: string, interpolateParams?: any, interpolationId?: string): ng.IPromise<string> => {
        const translation = translate(translationId, interpolateParams, interpolationId);
        return $q.when(translation);
      },
      {
        cloakClassName: unimplementedMethod,
        fallbackLanguage: unimplementedMethod,
        preferredLanguage: unimplementedMethod,
        proposedLanguage: unimplementedMethod,
        refresh: unimplementedMethod,
        storage: unimplementedMethod,
        storageKey: unimplementedMethod,
        use: unimplementedMethod,
        useFallbackLanguage: unimplementedMethod,
        versionInfo: unimplementedMethod,
        loaderCache: unimplementedMethod,
        isReady: unimplementedMethod,
        onReady: unimplementedMethod,
        resolveClientLocale: unimplementedMethod
      },
      {
        // We don't use postCompiling in VizPortal. For details on what this is:
        // https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translateProvider#methods_usepostcompiling
        isPostCompilingEnabled: () => false,

        instant: translate
      });
    return localizeToNgTranslateAdapter;
}]);
